import { allModelsSelector, singleModelSelector } from 'common-src/utils/selectorUtils';

import DashboardV2Appointment from './DashboardV2Appointment';

export const getDashboardV2Appointments = (state) =>
  allModelsSelector(state, DashboardV2Appointment.modelName).sort(
    (a, b) => new Date(a?.date || 0) - new Date(b?.date || 0),
  );

export const getDashboardV2Appointment = (state, id) =>
  singleModelSelector(state, DashboardV2Appointment.modelName, id);
